import { graphql } from "@server/gql";

export const stockWatchQuery = graphql(/* GraphQL */ `
  query stockWatch($items: [StockWatchItem!]!) {
    stockWatch(items: $items)
  }
`);
